import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, DatePicker, Drawer, Input, Field, Select, Toggle } from '@itds/elements/index.js';

const QuotePromotionModel = ({ carriers, onClose, onSave, products, promotion, show }) => {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    const new_promotion = promotion || {};

    const currentDate = new Date().toISOString();

    setData({
      id: new_promotion.id,
      mobile_app_guid: new_promotion.mobile_app_guid,
      is_active: !!new_promotion.is_active,
      carrier_id: new_promotion.carrier_id || '',
      product_id: new_promotion.product_id || 0,
      order: new_promotion.order || 1,
      start_date: new_promotion.start_date || currentDate,
      end_date: new_promotion.end_date || ''
    });
  }, [promotion]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleActiveChange = () => {
    setData({ ...data, is_active: !data.is_active });
  };

  const handleDateChange = (name, date) => {
    setData({ ...data, [name]: date });
  };

  const handleSave = () => {
    const errors = [];

    if (!data.carrier_id) {
      errors.push('carrier_id');
    }

    if (!data.start_date) {
      errors.push('start_date');
    }

    if (!data.end_date) {
      errors.push('end_date');
    }

    setErrors(errors);

    if (!errors.length) {
      window.scrollTo(0, 0);
      onSave(data);
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button onClick={handleSave}>{data.id ? 'Save Changes' : 'Create Quote Promotion'}</Button>
      }
      onClose={onClose}
      show={show}
      title={data.id ? 'Editing Quote Promotion' : 'New Quote Promotion'}
    >
      <Field>
        <Toggle active={data.is_active} onClick={handleActiveChange} />
      </Field>

      <Field label='Carrier'>
        <Select
          invalid={errors.includes('carrier_id')}
          onChange={handleInputChange.bind(null, 'carrier_id')}
          options={carriers}
          placeholder='No Carrier Selected'
          required={true}
          value={data.carrier_id}
        />
      </Field>

      {data.carrier_id ? (
        <Field label='Product'>
          <Select
            onChange={handleInputChange.bind(null, 'product_id')}
            options={[{ value: '', label: 'All Products' }].concat(
              products.filter(p => p.carrier_id === parseInt(data.carrier_id, 10))
            )}
            value={data.product_id}
          />
        </Field>
      ) : null}

      <Field description='The lowest number displayed at top' label='Order'>
        <Input
          onChange={handleInputChange.bind(null, 'order')}
          step={1}
          type='number'
          value={data.order}
        />
      </Field>

      <Field label='Start Date'>
        <DatePicker
          future={true}
          invalid={errors.includes('start_date')}
          onChange={handleDateChange.bind(null, 'start_date')}
          required={true}
          value={data.start_date}
        />
      </Field>

      <Field label='End Date'>
        <DatePicker
          future={true}
          invalid={errors.includes('end_date')}
          onChange={handleDateChange.bind(null, 'end_date')}
          required={true}
          value={data.end_date}
        />
      </Field>
    </Drawer>
  );
};

QuotePromotionModel.propTypes = {
  carriers: PropTypes.array,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  products: PropTypes.array,
  promotion: PropTypes.object,
  show: PropTypes.bool
};

export default QuotePromotionModel;
